import {replace, push} from "react-router-redux";
import {setDirty} from "../common/commonActions";
import {ajax, addPath, removePath, replacePath, parametrize, checkResponseOKStatus} from "../../common/utils";
import {URLs, PaymentMethod, FetchingTypes, PaymentTypes} from "../../common/constants";
import {saveToStorage} from "../common/storageActions";
import {setPostActionKey, updateACHPreapprovalAndSubmitOrder} from "../store/storeCheckoutActions";
import {fetchingData, dataFetched, errorFetching, isFetching} from '../common/fetchingActions';
import {setCustomAmount} from "../common/subscriptionSummaryActions";

export function getAuthorizedDotNetIFrameInfo(mode){
    return function (dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/WebStoreService.getAuthorizedDotNetIFrameInfo';
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey: state.summary.key,
            paymentMethod: PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key,
            mode: mode
        };
        return ajax(fetchUrl, data)
            .then(json => {
                    if (json.error)
                        throw new Error(json.error);
                    dispatch(handlePaymentRedirect({
                        httpMethod: json.httpMethod,
                        actionURL: json.actionURL,
                        parameters: json.parameters
                    }, PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key));
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}

export function handlePaymentRedirect(response, paymentMethod, callback){
    return function (dispatch, getState){
        const state = getState();
        if(response.actionURL != null){
            if (paymentMethod === PaymentMethod.PHONE) {
                //This is an workaround for BTC - real Phone cannot have redirect
                dispatch(setDirty(false));
                dispatch(saveToStorage());
                handleRedirect('POST', '_self', response.actionURL, response.parameters);
            } else
            if(paymentMethod === PaymentMethod.ELECTRONIC_CHECK.key || paymentMethod === PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key) {
                //ACH
                dispatch(setPostActionKey((response.parameters || {}).postAction || (response.parameters || {}).webOrder));
                dispatch(replace(addPath('echeck'+window.location.search)));
                dispatch(dataFetched());
            } else if (paymentMethod === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key || (state.staticData.isAuthorizeDotNetAcceptHostedEnabled && paymentMethod === PaymentMethod.AUTHORIZE_DOT_NET.key)){
                //Authorize.net proapproval or hosted form
                dispatch(setPostActionKey((response.parameters || {}).postAction || (response.parameters || {}).webOrder));
                dispatch(push(addPath("payments"+window.location.search)));
                handleRedirect(response.httpMethod, "paymentsHostIFrame", response.actionURL, response.parameters);
                dispatch(dataFetched());
            } else if (paymentMethod === PaymentMethod.EBT_ONLINE.key){
                dispatch(setPostActionKey((response.parameters || {}).postAction || (response.parameters || {}).webOrder));
                dispatch(setCustomAmount((response.parameters || {}).amount || '0'));
                dispatch(replace(addPath('ebt'+window.location.search)));
                dispatch(dataFetched());
            } else {
                //Paypal
                dispatch(setDirty(false));
                dispatch(saveToStorage());
                let method = response.actionURL.includes('webscr') ? 'GET' : 'POST';
                handleRedirect(method, '_self', response.actionURL, response.parameters);
            }
        }else {
            dispatch(setDirty(false));
            if (callback)
                dispatch(callback);
            dispatch(dataFetched());
        }
    }
}

export function handleRedirect(method, target, actionURL, parameters){
    if (method == 'GET') {
        const goToUrl = actionURL + "?" +  parametrize(parameters);
        window.location = goToUrl;
    }else {
        let form = document.createElement("form");
        form.setAttribute("method", method);
        form.setAttribute("action", actionURL);
        form.setAttribute("target", target);

        for(let key in parameters) {
            if(parameters.hasOwnProperty(key)) {
                let field = document.createElement("input");
                field.setAttribute("type", "hidden");
                field.setAttribute("name", key);
                field.setAttribute("value", parameters[key]);
                form.appendChild(field);
            }
        }
        document.body.appendChild(form);
        form.submit();
    }
}

export function makeExtraPayment(clientMode, amount, paymentMethod, paymentPlan) {
    return function(dispatch, getState){
        const state = getState();
        if(!isFetching(state, FetchingTypes.SUBMIT)) {
            dispatch(fetchingData(FetchingTypes.SUBMIT));
        } else {
            return;
        }
        const fetchUrl = '/dispatcher/WebStoreService.makeExtraPayment';
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey:state.summary.key,
            clientMode: clientMode,
            paymentPlanKey: paymentPlan.key,
            amount: amount,
            paymentMethod: paymentMethod
        };
        return ajax(fetchUrl, data)
            .then(json => {
                dispatch(handlePaymentRedirect(json, paymentMethod, replace(addPath('thankyou'))));
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}
export function redirectToPaymentDetails(mode, paymentMethod, paymentPlan) {
    return function(dispatch, getState){
        const state = getState();
        if(!isFetching(state, FetchingTypes.SUBMIT)) {
            dispatch(fetchingData((FetchingTypes.SUBMIT)));
        } else {
            return;
        }
        //In case of auth.net preapparoval need only to create a token
        if (paymentMethod === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key){
            dispatch(getAuthorizedDotNetIFrameInfo(mode));
            return;
        }
        const fetchUrl = "/dispatcher/WebStoreService.redirectToPaymentDetails";
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey:state.summary.key,
            mode: mode,
            paymentMethod: paymentMethod,
        };
        if(paymentPlan) {
          data.paymentPlanKey = paymentPlan.key;
        }
        return ajax(fetchUrl, data)
            .then(json => {
                dispatch(handlePaymentRedirect(json, paymentMethod, replace(addPath('thankyou'))));
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}

export function updatePaymentPlan(paymentPlan) {
    return function (dispatch, getState) {
        const state = getState();
        if(!isFetching(state, FetchingTypes.SUBMIT)) {
            dispatch(fetchingData(FetchingTypes.SUBMIT));
        } else {
            return;
        }
        const fetchUrl = "/dispatcher/WebStoreService.updatePaymentPlan";
        let data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey: state.summary.key
        };
        if (paymentPlan) {
            data['paymentPlanKey'] = paymentPlan.key;
        }
        return ajax(fetchUrl, data)
            .then(json =>
            {
                checkResponseOKStatus(json);
                dispatch(setDirty(false));
                dispatch(replace(addPath('thankyou')));
                dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}

export function checkAuthorizeDotNetTokenAndUpdatePayments(){
    return function(dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/WebStoreService.checkAuthorizeDotNetToken';
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscription: state.summary.key
        };
        if (state.checkout.postActionKey)
            data.postAction = state.checkout.postActionKey;
        return ajax(fetchUrl, data)
            .then(json => {
                checkResponseOKStatus(json);
                if (state.summary.autoPaymentPlan) {
                    dispatch(updatePaymentPlan(state.summary.autoPaymentPlan));
                } else {
                    dispatch(setDirty(false));
                    dispatch(replace(replacePath('thankyou')));
                    dispatch(dataFetched());
                }

            })
            .catch(error => {
                dispatch(replace(removePath('/payments')));
                dispatch(errorFetching(error));
            });
    }
}

export function processAuthorizeDotNetResponse(amount, responseCode, txnId, flow){
    return function(dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/PaymentsService.processHostedAuthorizeDotNetResponse';
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey: state.summary.key,
            amount,
            responseCode,
            txnId,
            flow
        };
        if (state.checkout.postActionKey) {
            if (flow === 'STORE_STANDARD') {
                data.webOrder = state.checkout.postActionKey;
            } else {
                data.postAction = state.checkout.postActionKey;
            }
        }
        return ajax(fetchUrl, data)
            .then(json => {
                checkResponseOKStatus(json);
                dispatch(setDirty(false));
                dispatch(replace(replacePath('thankyou')));
                dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(replace(removePath('/payments')));
                dispatch(errorFetching(error));
            });
    }
}

export function submitEcheck(echeckInfo, isChargeOnDelivery, pageContext){
    return function(dispatch) {
        if (isChargeOnDelivery && pageContext === URLs.STORE)
            dispatch(authenticateACH(echeckInfo, pageContext, updateACHPreapprovalAndSubmitOrder));
        else
            dispatch(authenticateACH(echeckInfo, pageContext, createEcheck));
    }
}

function authenticateACH(echeckInfo, pageContext, callback){
    return function(dispatch, getState){
        const state = getState();
        if(!isFetching(state, FetchingTypes.SUBMIT)) {
            dispatch(fetchingData(FetchingTypes.SUBMIT));
        } else {
            return;
        }
        const fetchUrl = '/dispatcher/WebStoreService.authenticateACH';
        return ajax(fetchUrl, echeckInfo)
            .then(json => {
                checkResponseOKStatus(json);
                dispatch(callback(echeckInfo, pageContext));
            }).catch(error => {
                const suppressError = error.message.startsWith('Please double check the information you provided') || error.message.startsWith('Invalid Bank Routing Number') || error.message.startsWith('The Details you provided failed authentication') || error.message.startsWith('Timeout expired');
                dispatch(errorFetching(error, undefined, suppressError));
            });
    }
}

function createEcheck(echeckInfo, pageContext){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = pageContext === URLs.STORE ? '/dispatcher/WebStoreService.createEcheckSubscriptionForWebOrder' :
            (pageContext === URLs.PAY && (state.summary.paymentType === PaymentTypes.AUTO_PAYMENT.type || state.summary.paymentType === PaymentTypes.UPDATE_PAYMENT.type || state.summary.paymentType === PaymentTypes.PAYMENT_TOKEN.type)) ? '/dispatcher/WebStoreService.updateACHPreapproval' :
                (pageContext === URLs.PAY && state.summary.paymentType === PaymentTypes.CHARGE.type) ? '/dispatcher/WebStoreService.createEcheckSubscriptionWithAmount' :
                    '/dispatcher/WebStoreService.createEcheckSubscription';

        if (state.summary.paymentType === PaymentTypes.CHARGE.type)
            echeckInfo.amount = state.summary.chargePaymentPlan.amount;
        return ajax(fetchUrl, echeckInfo)
            .then(json => {
                checkResponseOKStatus(json);
                if (pageContext === URLs.PAY && state.summary.paymentType === PaymentTypes.AUTO_PAYMENT.type && state.summary.autoPaymentPlan) {
                    dispatch(dataFetched());
                    dispatch(updatePaymentPlan(state.summary.autoPaymentPlan));
                } else {
                    dispatch(setDirty(false));
                    dispatch(replace(replacePath('thankyou')));
                    dispatch(dataFetched());
                }
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}

export function initEBT(ebtInfo, pageContext){
    return function(dispatch, getState){
        const state = getState();
        if(!isFetching(state, FetchingTypes.SUBMIT)) {
            dispatch(fetchingData(FetchingTypes.SUBMIT));
        } else {
            return;
        }
        ebtInfo.flow = pageContext === URLs.STORE ? 'STORE_STANDARD' :
            window.location.href.includes('/charge/') ? 'CHARGE_FROM_MEMBER_CARD' :
                pageContext === 'BALANCE' ? 'BALANCE' :
                    'STANDARD';
        ebtInfo.cancelUrl = window.location.href;
        const fetchUrl = '/dispatcher/WebStoreService.initEBT';
        return ajax(fetchUrl, ebtInfo)
            .then(response => {
                checkResponseOKStatus(response);
                dispatch(setDirty(false));
                dispatch(saveToStorage());
                const redirectInfo = response.redirectInfo;
                handleRedirect('POST', '_self', redirectInfo.actionURL, redirectInfo.parameters);
            }).catch(error => {
                // const suppressError = error.message && (error.message.startsWith('Please double check the information you provided') || error.message.startsWith('Timeout expired'));
                const suppressError = false;
                dispatch(errorFetching(error, undefined, suppressError));
            });
    }
}

export function adminChargeWithToken() {
    return (dispatch, getState) => {
        const state = getState();
        if(!isFetching(state, FetchingTypes.SUBMIT)) {
            dispatch(fetchingData(FetchingTypes.SUBMIT));
        } else {
            return;
        }
        const paymentMethodToken = state.summary.paymentMethodToken;
        const amount = state.summary.chargePaymentPlan.amount;
        const fetchUrl = paymentMethodToken === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key ? "/dispatcher/WebStoreService.createAuthorizeDotNetTransactionWithAmount" :
            paymentMethodToken === PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key ? "/dispatcher/WebStoreService.createEcheckTransactionWithAmountFromExistingConsumer" :
                undefined;
        if (!fetchUrl)
            return;
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey: state.summary.key,
            amount: amount
        };
        return ajax(fetchUrl, data)
            .then(json => {
                if (json.statusCode !== "OK") {
                    dispatch(errorFetching(new Error(json.message), undefined, true));
                } else {
                    dispatch(setDirty(false));
                    dispatch(replace(replacePath('thankyou')));
                    dispatch(dataFetched());
                }
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}

export function adminChargeWithoutToken() {
    return (dispatch, getState) => {
        const state = getState();
        if (state.summary.chargePaymentMethod === PaymentMethod.ELECTRONIC_CHECK.key) {
            dispatch(replace(addPath('echeck' + window.location.search)));
        } else if (state.summary.chargePaymentMethod === PaymentMethod.EBT_ONLINE.key){
            dispatch(replace(addPath('ebt' + window.location.search)));
        } else if (state.summary.chargePaymentMethod === PaymentMethod.AUTHORIZE_DOT_NET.key){
            if(!isFetching(state, FetchingTypes.SUBMIT)) {
                dispatch(fetchingData(FetchingTypes.SUBMIT));
            } else {
                return;
            }
            const fetchUrl = "/dispatcher/WebStoreService.redirectAuthorizeAndCaptureAuthorizeDotNetWithAmount";
            const data = {
                farmKey: state.staticData.farmKey,
                memberKey: state.memberDetails.key,
                subscriptionKey: state.summary.key,
                amount: state.summary.chargePaymentPlan.amount
            };
            return ajax(fetchUrl, data)
                .then(json => {
                    if (json.error)
                        throw new Error(json.error);
                    dispatch(handlePaymentRedirect(json, PaymentMethod.AUTHORIZE_DOT_NET.key, replace(replacePath('thankyou'))));
                })
                .catch(error => {
                    dispatch(errorFetching(error));
                });
        }
    }
}

export function removeAutomaticPayment() {
    return (dispatch, getState) => {
        const state = getState();
        if(!isFetching(state, FetchingTypes.SUBMIT)) {
            dispatch(fetchingData(FetchingTypes.SUBMIT));
        } else {
            return;
        }
        const fetchUrl = "/dispatcher/WebStoreService.removeAutomaticPayment";
        const data = {
            farmKey: state.staticData.farmKey,
            subscriptionKey: state.summary.key,
            memberKey: state.memberDetails.key,
            paymentMethod: state.summary.paymentMethodToken
        };
        return ajax(fetchUrl, data)
            .then(json => {
                checkResponseOKStatus(json);
                dispatch(setDirty(false));
                dispatch(replace(replacePath('thankyou')));
                dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(errorFetching(error));
            });
    }
}




// WEBPACK FOOTER //
// ./src/actions/pay/paymentActions.js